export const SETTLEMENT_NAV_PENDING_EVENT = 'dq:settlement-nav-pending';

/** Sidebar pending dot. Call this from a settlement screen that already loaded the data. */
export const publishSettlementNavPending = (path, pending) => {
  if (!path || typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SETTLEMENT_NAV_PENDING_EVENT, {
    detail: { path, pending: Boolean(pending) },
  }));
};
